import React from 'react';
import RHFToggle from '../controls/tempRHFControls/RHFToggle';
import RHFInputBox from '../controls/tempRHFControls/RHFInputBox';
import { UseFormMethods } from 'react-hook-form';

interface IProvisionClauseProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    label: string;
    formPrefix: string;
    key?: string;
    showDescription?: boolean;
    descriptionRequired?: boolean;
    inputStyle?: React.CSSProperties;
    toggleStyle?: React.CSSProperties;
    style?: React.CSSProperties;
}

const ProvisionClause = (props: IProvisionClauseProps) => {
    return (
        <div style={{ marginRight: '1rem' }} key={props.key}>
            <input type="hidden" name={`${props.formPrefix}.provisionLeaseClauseId`} ref={props.register()} />
            <input type="hidden" name={`${props.formPrefix}.contractLookupId`} ref={props.register()} />
            <input type="hidden" name={`${props.formPrefix}.id`} ref={props.register()} />
            <div>
                <RHFToggle
                    name={`${props.formPrefix}.isSelected`}
                    label={props.label}
                    register={props.register}
                    errors={props.errors}
                    bodyStyle={props?.toggleStyle}
                />
            </div>
            {props.descriptionRequired === true && (
                <div>
                    <RHFInputBox
                        label="Description"
                        name={`${props.formPrefix}.description`}
                        register={props.register}
                        errors={props.errors}
                        className="description"
                        bodyStyle={props?.inputStyle}
                        style={props?.style}
                    />
                </div>
            )}
        </div>
    );
};

export default ProvisionClause;


// WEBPACK FOOTER //
// ./src/components/common/ProvisionClause.tsx